import { TaggingTypeEnum } from '../../enums';

import { TaggingActionPayload, TaggingViewPayload } from '../../models';

import { ApiService } from '../api.service';
import { TaggingService } from '../interfaces/tagging.service';

export class TaggingApiService extends ApiService implements TaggingService {

  private static readonly ENDPOINTS = {
    [TaggingTypeEnum.VIEW]: '/view',
    [TaggingTypeEnum.ACTION]: '/action'
  };

  constructor(protected readonly BASE_URL: string) {
    super(BASE_URL);
  }

  public tagView(instance: string, payload: TaggingViewPayload, sessionId: string): Promise<void> {
    return this.tag(TaggingTypeEnum.VIEW, instance, payload, sessionId);
  }

  public tagAction(instance: string, payload: TaggingActionPayload, sessionId: string): Promise<void> {
    return this.tag(TaggingTypeEnum.ACTION, instance, payload, sessionId);
  }

  private async tag(type: TaggingTypeEnum, instance: string, payload: TaggingViewPayload | TaggingActionPayload,
    sessionId: string): Promise<void> {
    const requestParams = {
      ...payload,
      session_id: sessionId
    };
    const requestInit: RequestInit = {
      method: 'POST'
    };
    try {
      await this.fetch<void>(
        `${ TaggingApiService.ENDPOINTS[type] }/${ instance }`,
        requestParams,
        requestInit
      );
    } catch (error) {
      console.error(error);
    }
  }

}
